import { AssetRenamePanelAction, AssetRenamePanelActionKeys } from './actions';

interface AssetRenamePanelState {
	isOpen: boolean;
	name: string;
	error: null | string;
	assetId: number;
}

const initialState: AssetRenamePanelState = {
	isOpen: false,
	name: '',
	error: null,
	assetId: -1,
};

function assetRenamePanel(state: AssetRenamePanelState = initialState, action: AssetRenamePanelAction): AssetRenamePanelState {
	switch (action.type) {
		case AssetRenamePanelActionKeys.OPEN_PANEL:
			return {
				...state,
				isOpen: true,
			};
		case AssetRenamePanelActionKeys.CLOSE_PANEL:
			return initialState;
		case AssetRenamePanelActionKeys.SET_NAME:
			return {
				...state,
				name: action.name,
				error: null,
			};
		case AssetRenamePanelActionKeys.SET_ERROR:
			return {
				...state,
				error: action.error,
			};
		case AssetRenamePanelActionKeys.SET_DRIVE_ITEM_ID:
			return {
				...state,
				assetId: action.id,
			};
		default:
			return state;
	}
}

export {
	AssetRenamePanelState,
	assetRenamePanel
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/AssetRenamePanel/reducer.ts